import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const { language, setLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => navigate('/')}>
            <img
              src="https://static.readdy.ai/image/78b249b905e2bab988df960bca6da6fd/396f56bc326bf3bb0133c4916831ad74.png"
              alt="ComiAI Logo"
              className="h-10 w-auto"
            />
            <span className={`text-xl font-bold ${isScrolled ? 'text-gray-900' : 'text-gray-900'}`}>
              {t('可画科技国际有限公司', 'ComiAI International Technology Limited')}
            </span>
          </div>

          <div className="flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('overview')}
              className={`text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-gray-900 hover:text-red-600'
              }`}
            >
              {t('关于我们', 'About Us')}
            </button>
            <button
              onClick={() => scrollToSection('products')}
              className={`text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-gray-900 hover:text-red-600'
              }`}
            >
              {t('产品', 'Products')}
            </button>
            <button
              onClick={() => scrollToSection('team')}
              className={`text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-gray-900 hover:text-red-600'
              }`}
            >
              {t('团队', 'Team')}
            </button>

            <button
              onClick={() => navigate('/contact')}
              className={`text-sm font-bold transition-colors whitespace-nowrap cursor-pointer ${
                isScrolled ? 'text-gray-900 hover:text-red-600' : 'text-gray-900 hover:text-red-600'
              }`}
            >
              {t('联系我们', 'Contact Us')}
            </button>
            
            {/* Language Switcher */}
            <div className="flex items-center space-x-2 bg-gray-100 rounded-full p-1">
              <button
                onClick={() => setLanguage('zh')}
                className={`px-3 py-1.5 text-xs font-bold rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  language === 'zh'
                    ? 'bg-red-600 text-white shadow-md'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                中文
              </button>
              <button
                onClick={() => setLanguage('en')}
                className={`px-3 py-1.5 text-xs font-bold rounded-full transition-all whitespace-nowrap cursor-pointer ${
                  language === 'en'
                    ? 'bg-red-600 text-white shadow-md'
                    : 'text-gray-600 hover:text-gray-900'
                }`}
              >
                English
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
